import React, { Component } from "react";
import AntdLocaleProvider, {
  LocaleProviderProps
} from "antd/lib/locale-provider";
import "antd/lib/locale-provider/style";

export default class LocaleProvider extends Component<LocaleProviderProps> {
  render() {
    const { children } = this.props;
    return <AntdLocaleProvider {...this.props}>{children}</AntdLocaleProvider>;
  }
}



// WEBPACK FOOTER //
// ./src/components/locale-provider/index.tsx